import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a4bfefec2e0eff38786683980d51cd988b from "./generated-fdf4fc06-0484-463f-b725-cc5bb7294cdf.json";

import a094b940f6e8c381a7aa4b21a5f02d07db from "./generated-b81e11fe-d803-4d3b-a32f-f697b9ed0b2b.json";

import acef5c72671254d019691b7bdb8e7cebab from "./generated-93d9fca0-c083-449e-a0a2-5409f245e42a.json";

import a580cc238be86a54bbe6fff048f7a5546b from "./generated-2fb4da54-09b4-4a44-bb5e-f855d50104ed.json";

import a677d88c6fa2f62b508b6d54ed83de009b from "./generated-31770dc0-53d4-4fc2-ac2f-fbad99702980.json";

import a9a9068abb07a01833b0d13fca209c46bb from "./generated-5b7f427b-cd53-4032-8b89-f54a02571ce0.json";

import a8a44389b4e4dfa8f8d5289778720c50cb from "./generated-bb9957f0-d41a-4411-bfaa-2c833fdad08d.json";

import a5bd5bd8fbbf4bb6d8012d3590504bd28b from "./generated-10f9185d-4b5a-4822-a630-fb0922bad54a.json";

import aa2aa21f1bb7f5c70b469dddefcc9d000b from "./generated-24d2b221-9430-4f9f-bea4-64d5bd5c10e5.json";

import a774ab1e14f2c839d46f66c1241d53857b from "./generated-b8079ca2-d1c0-401b-80cf-c54e87b2b946.json";

import ae479ef2a2383e220007c1f39f8a0d7b8b from "./generated-df47abc2-7256-4ad3-a72b-fe27d1f5657f.json";

import aa05ef8e0b5164d81ceb0e17106ae01e3b from "./generated-df6afc9f-3c6c-4a8f-ae2c-62e96a0824bb.json";

import a1cf8284658364830b83da9b597659df0b from "./generated-566bf296-e7b7-466f-aeaf-f0fc18a6a37c.json";

import ab983498a4073aae0df073b0678a84330b from "./generated-b48b09ef-987f-4a8a-b3fe-6e6ee6b93e6a.json";

import a7418568513f0df4744996b8456bcf198b from "./generated-d34d4a64-5d36-4daa-a396-28f06777d9a5.json";

import a8b89dc4a219c67e8a8b1276f416a6eabb from "./generated-19010600-cda8-472f-9ea6-9ac2b0bfa1f8.json";

import a102744ff26bd7aa8ceddfa4fbfcd363cb from "./generated-12d78c94-b05c-4c91-9668-d9004a8bc372.json";

import abed5da9353f6b069cc474d90cae1915fb from "./generated-cd416465-f446-4049-a1f8-31bc52ab2f8e.json";

import a1508af2245fc9500eebb1362ab9ed3bfb from "./generated-202c433c-064a-404d-8e84-7798fe4ca49b.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a4bfefec2e0eff38786683980d51cd988b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a094b940f6e8c381a7aa4b21a5f02d07db);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(acef5c72671254d019691b7bdb8e7cebab);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a580cc238be86a54bbe6fff048f7a5546b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a677d88c6fa2f62b508b6d54ed83de009b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a9a9068abb07a01833b0d13fca209c46bb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a8a44389b4e4dfa8f8d5289778720c50cb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a5bd5bd8fbbf4bb6d8012d3590504bd28b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(aa2aa21f1bb7f5c70b469dddefcc9d000b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a774ab1e14f2c839d46f66c1241d53857b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(ae479ef2a2383e220007c1f39f8a0d7b8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(aa05ef8e0b5164d81ceb0e17106ae01e3b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a1cf8284658364830b83da9b597659df0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(ab983498a4073aae0df073b0678a84330b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a7418568513f0df4744996b8456bcf198b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a8b89dc4a219c67e8a8b1276f416a6eabb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a102744ff26bd7aa8ceddfa4fbfcd363cb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(abed5da9353f6b069cc474d90cae1915fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a1508af2245fc9500eebb1362ab9ed3bfb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a102744ff26bd7aa8ceddfa4fbfcd363cb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */